<template>
  <model-form
    :model="payment"
    width="550px"
    modal-type="modal"
  >
    <div>
      <div class="row q-gutter-md q-mb-md">
        <q-input
          :model-value="$_.startCase(payment.type)"
          class="col"
          label="Type"
          readonly
        />
        <q-input
          :model-value="$_.startCase(payment.subtype)"
          class="col"
          label="Subtype"
          readonly
        />
        <q-input
          :model-value="$_.startCase(payment.state)"
          class="col"
          label="State"
          readonly
        />
      </div>
      <div class="row q-gutter-md q-mb-md">
        <q-input
          v-model="payment.amount"
          class="col"
          label="Amount"
          prefix="$"
          readonly
        />
        <q-input
          :model-value="payment.paidAt ? payment.paidAt.i18n('timestamp') : null"
          class="col"
          label="Paid At"
          readonly
        />
      </div>
      <div class="row q-gutter-md q-mb-md">
        <q-btn
          v-if="payment.employee"
          class="col sensitive-button"
          color="primary"
          outline
          :label="payment.employee.name"
          @click="$editModel(payment.employee)"
        />
        <q-input
          :model-value="payment.registerStation && payment.registerStation.name"
          class="col"
          label="Register"
          readonly
        />
      </div>
      <div class="row q-gutter-md q-mb-md">
        <q-input
          :model-value="$_.startCase(payment.cardType)"
          class="col"
          label="Card Type"
          readonly
        />
        <q-input
          v-model="payment.nameOnCard"
          class="col"
          label="Name On Card"
          readonly
        />
        <q-input
          v-model="payment.lastFour"
          class="col"
          label="Last Four"
          readonly
        />
      </div>
      <div
        v-if="payment.type === 'custom'"
        class="row q-gutter-md q-mb-md"
      >
        <q-input
          :model-value="payment.details"
          class="col"
          label="Details"
          readonly
        />
      </div>
      <div
        v-if="payment.paymentConnectorStatusDetails"
        class="row q-gutter-md q-mb-md"
      >
        <q-input
          v-model="payment.paymentConnectorResponseCode"
          readonly
          class="col"
          label="Payment Connector Response Code"
        />

        <q-input
          v-model="payment.paymentConnectorResponseMessage"
          readonly
          class="col"
          label="Payment Connector Response Message"
        />
      </div>
      <div
        v-if="payment.paymentConnectorStatusDetails"
      >
        <div class="row q-gutter-md q-mb-md">
          <q-input
            v-for="reference in payment.connectorPaymentReferences"
            :key="reference.name"
            :model-value="reference.value"
            readonly
            class="col"
            :label="$_.startCase(reference.name)"
          />
        </div>
        <div class="row q-gutter-md q-mb-md">
          <q-btn
            v-if="payment.paymentConnectorStatusDetails.merchant_receipt_data"
            class="col"
            color="primary"
            outline
            label="View Merchant Receipt"
            @click="() => showReceiptDialog(false)"
          />
          <q-btn
            v-if="payment.paymentConnectorStatusDetails.customer_receipt_data"
            class="col"
            color="primary"
            outline
            label="View Customer Receipt"
            @click="() => showReceiptDialog(true)"
          />
        </div>
      </div>
      <div
        v-if="payment.isStripe"
        class="row q-gutter-md q-mb-md"
      >
        <q-input
          v-model="payment.stripePaymentMethodId"
          class="col"
          label="Stripe Payment Method"
          readonly
        />
        <q-input
          v-model="payment.stripePaymentIntentId"
          class="col"
          label="Stripe Payment Intent"
          readonly
        />
        <q-input
          v-model="payment.stripePaymentMethodFingerprint"
          class="col"
          label="Payment Fingerprint"
          readonly
          :class="$admin && payment.stripePaymentMethodFingerprint ? 'cursor-pointer' : null"
        >
          <template #append>
            <q-icon
              name="search"
              @click="$admin && $search.show(payment.stripePaymentMethodFingerprint)"
            />
          </template>
        </q-input>
      </div>
      <div
        v-if="payment.isStripe"
        class="row q-col-gutter-md q-mb-md"
      >
        <q-input
          v-model="payment.stripeFailureMessage"
          class="col-8"
          label="Stripe Failure Message"
          readonly
        />
        <div class="col-4 row items-center">
          <q-btn
            v-model="payment.stripeFailureMessage"
            outline
            class="col"
            color="primary"
            label="Order"
            @click="$editModel(payment.order)"
          />
        </div>
      </div>
    </div>
    <payment-connector-receipt-dialog ref="paymentConnectorReceiptDialog" />
  </model-form>
</template>

<script>

import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import PaymentConnectorReceiptDialog from 'src/modules/admin/payment/components/PaymentConnectorReceiptDialog.vue'

export default {
  name: 'PaymentForm',
  components: {
    ModelForm,
    PaymentConnectorReceiptDialog
  },
  models: {
    payment: {
      order: true,
      employee: true,
      connectorPaymentReferences: true
    }
  },
  methods: {
    showReceiptDialog (customerReceipt = false) {
      const receiptData = this.payment.paymentConnectorStatusDetails[`${customerReceipt ? 'customer' : 'merchant'}_receipt_data`]
      const receiptType = this.payment.paymentConnectorStatusDetails?.receipt_type
      this.$refs.paymentConnectorReceiptDialog.show(receiptData, receiptType, this.payment.id, customerReceipt)
    }
  }
}

</script>
